export const importPreview3d = async () => await import(
    /* Comments required by webpack: */
    /* webpackChunkName: "preview" */
    /* webpackPreload: true */
    'ff-preview-3d'
);